<template>
  <div 
    style="max-width: 500px; position: relative; height:100%; overflow: hidden;" 
    class="Kanit mx-auto bg-subpage-black">

      <!-- Header -->
     <Header :isHeaderFixed="false" :subpageLogoColor="'white'" :isMenuBlack="false"></Header>

    <v-slide-x-transition leave-absolute hide-on-leave>
      <div class="px-4" style="padding-top: 10%;" v-if="!loadMember">
        <div class="text-right">
          <v-btn
            icon
            @click="onEditProfile()"
          >
            <v-icon>
              mdi-pencil-outline
            </v-icon>
          </v-btn>
        </div>
        
        <h3 class="text-center mb-3" style="padding-top: 6%; font-size: 20px; font-weight: 700;" >ข้อมูลของฉัน</h3>
        <div v-if="!isEditProfile">
          <!-- Member Card -->
          <template v-if="!loading">
            <member-card></member-card>
          </template>
          <template v-else>
            <div class="text-center">
              <v-progress-circular
                indeterminate
                class="mt-6"
                color="primary"
                size="65"
              ></v-progress-circular>
            </div>
          </template> 
          
          <div class="mt-6">
            <div class="primary--text">วันหมดอายุสมาชิก</div>
            <div style="border-bottom: 1px solid #ccc;">
              {{ moment(member.expired_timestamp).add(543, "year").format("DD/MM/YYYY") }}
            </div>
          </div>
          <!-- History Orders -->
          <div v-if="!showHistoryOrders" style="margin-top: 32px;">
            <v-btn
              tile
              dark
              color="#000"
              @click="onHistoryOrders(true)"
              style="width: 100%; height: 48px;"
            >
              <div class="text-left float-left" style="width: 90%;">
                <v-icon color="primary" left>
                  mdi-cart
                </v-icon>
                <span>ประวัติการสั่งซื้อ</span>
              </div>
              <div class="text-right float-right" style="width: 10%">
                <v-icon color="primary" x-large>
                  mdi-chevron-right
                </v-icon>
              </div>
            </v-btn>
          </div>
          <div v-else style="margin-top: 32px;">
            <div 
              style="background-color: #000; height: 48px; width: 100%; font-size: 18px; font-weight: 700; align-items: center;" 
              class="text-center primary--text mb-6 d-flex justify-center align-center"
            >
              ประวัติการสั่งซื้อ
            </div>
            <div>
              <HistoryOrders></HistoryOrders>
            </div>
            <div style="margin-top: 16px;">
              <v-btn
                tile
                dark
                color="#000"
                @click="onHistoryOrders(false)"
                style="width: 100%; height: 48px;"
              >
                <div>
                  <v-icon color="primary" left>
                    mdi-arrow-left
                  </v-icon>
                  <span>ย้อนกลับ</span>
                </div>
              </v-btn>
            </div>
          </div>
        </div>
        <div v-else>
          <profile-form
            :type="'edit'"
            :dataEdit="member"
            @editSuccess="onEditSuccess"
          ></profile-form>
        </div>
      </div>
      <div v-else style="padding-top: 50%;">
        <div class="text-center">
          <v-progress-circular
            indeterminate
            class="mt-6"
            color="primary"
            size="65"
          ></v-progress-circular>
        </div>
      </div>
    </v-slide-x-transition>

  </div>
</template>

<script>
  import axios from "axios";
  import moment from "moment";
  import Header from "@/components/Header.vue";
  import ProfileForm from "./ProfileForm.vue";
  import HistoryOrders from "./HistoryOrders.vue";
  import MemberCard from "./MemberCard.vue";

  
  export default {
    data() {
      return {
        showHistoryOrders: false,
        isEditProfile: false,
        // member: {},
        totalPurchase: '',
        loading: false,
        remark: '',
        bgCard: '',
        isShowCard : false,
        loadMember: false,
      }
    },
    components: {
      Header,
      ProfileForm,
      HistoryOrders,
      MemberCard
    },
    mounted() {
      // this.member = this.$store.state.member;
      // alert(Object.keys(this.member).length);
      if(Object.keys(this.member).length == 0) {
        this.loadMember = true;
      }
      
    },
    computed: {
      moment() {
        return moment;
      },
      member() {
        return this.$store.state.member;
      }
    },
    methods: {
      getMemberData() {
        var vm = this;
        return new Promise((resolve) => {
          var data = { 
            userid: vm.$store.state.userid, 
            pageid: vm.$route.query.pageid
          };

          axios
            .get(vm.serverUrl + "lamy/member", {
              headers: { AUTHORIZATION: "Bearer xxx xxx" },
              params: data,
            })
            .then(async (response) => {
              if (response.data.responsecode == 200) {
                vm.$store.state.member = response.data.data[0];
                vm.$store.state.member.totalPurchase = response.data.all_total_purchase;
                // vm.member =  vm.$store.state.member;

              } else if(response.data.responsecode == 204) {
                this.$router.push({
                  path: 'home',
                  query: {...this.$route.query } ,
                });
              } else {
                await vm.$swal.fire({ text: response.data.reason, confirmButtonColor: '#000' });
                vm.$liff.closeWindow();
              }
              resolve();
            });
        });
      },
      onHistoryOrders(status) {
        if(status) {
          this.showHistoryOrders = true;
        } else {
          this.showHistoryOrders = false;
        }
        
      },  
      onEditProfile() {
        this.isEditProfile = true;
      },
      onEditSuccess() {
        this.getMemberData();
        this.isEditProfile = false;
      },
      changePage(name) {
        var path = "/"+name;
        if (this.$route.path !== path) {
          this.$router.push({
            path: name,
            query: {...this.$route.query } ,
          }).catch({});
        }
      },
    },
    watch : {
      member(newval,oldval) {
        if(newval != oldval) {
          this.loadMember = false;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
@media screen and (min-width: 321px) {
  .member-card {
    background-size: contain;
    background-repeat: no-repeat;
    width: 350px;
    height: 215px;
    margin: 0 auto;
    position: relative;
  }
  .member-card-text {
    position: absolute;
    top: 100px;
    left: 0;
    font-size: 12px;
    max-width: 180px;
    width: 100%;
    padding-left: 30px;
  }
  .member-card-name {
    font-size: 14px; 
    font-weight: 700;
  }
  .profile-image-wrapper {
    width: 120px;
    height: 120px;
    position: absolute;
    right: 0;
    margin-right: 40px;
    margin-top: 50px;
  }
  .profile-image {
    width: 100%;
    height: auto;
    border-radius: 50%;
  }
}
// For Iphone 5
@media screen and (max-width: 320px) {
  .member-card {
    background-size: contain;
    background-repeat: no-repeat;
    width: 300px;
    height: 185px;
    margin: 0 auto;
    position: relative;
  }
  .member-card-text {
    position: absolute;
    top: 80px;
    left: 0;
    font-size: 11px;
    max-width: 155px;
    width: 100%;
    padding-left: 26px;
  }
  .member-card-name {
    font-size: 13px; 
    font-weight: 700;
  }
  .profile-image-wrapper {
    width: 120px;
    height: 120px;
    position: absolute;
    right: 0;
    margin-right: 40px;
    margin-top: 50px;
  }
  .profile-image {
    width: 100%;
    height: auto;
    border-radius: 50%;
  }
}
.v-application--is-ltr .v-btn__content .v-icon--left {
  margin-left: 0 !important;
}
</style>